export default {"src":"/_next/static/media/vivrelle-wordmark-black.c2bcc702.svg","height":21,"width":124,"blurWidth":0,"blurHeight":0};